import { useMutation } from "@apollo/client";
import { useRoute } from "@react-navigation/native";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import {
  Button,
  Page,
  Text,
  VStack,
  View,
  useFlashMessages,
} from "@towersystems/roam-common-native";
import { DeletionResult } from "@towersystems/roam-common/lib/generated-types";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PhotoImageRootParamList } from "../../../../types";
import { keys } from "../../../../utilities/i18n";
import { DELETE_PRODUCT_IMAGE } from "./constants";

export type ProductImageDeleteScreenProps = NativeStackScreenProps<
  PhotoImageRootParamList,
  "ProductImageDeleteScreen"
> & {};

export const ProductImageDeleteScreen = ({
  navigation,
}: ProductImageDeleteScreenProps) => {
  const { t } = useTranslation();
  const { showMessage } = useFlashMessages();

  const [loading, setLoading] = useState<boolean>(false);

  const [deleteImage] = useMutation<{ deleteProductImage: DeletionResult }>(
    DELETE_PRODUCT_IMAGE
  );

  const {
    params: { imageIds },
  } = useRoute<any>();

  async function deleteImageAsync(imageId: string) {
    return deleteImage({
      variables: {
        imageId: imageId,
      },
    });
  }

  async function handleDeleteImages(imageIds: string[]) {
    setLoading(true);
    return Promise.all(imageIds.map((imageId) => deleteImageAsync(imageId)))
      .then((res) => {
        navigation.goBack();
      })
      .catch((err) => {
        showMessage({
          message: "Error deleting images",
          severity: "error",
        });
      })
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    navigation.setOptions({
      title: t(keys.deleteImages, { count: imageIds.length }),
    });
  }, [imageIds]);

  const footerMarkup = (
    <View>
      <Button
        fullWidth
        style={{}}
        loading={loading}
        onPress={() => {
          handleDeleteImages(imageIds);
        }}
        isDestructive={true}
        label="Delete"
      />
    </View>
  );

  return (
    <Page footer={footerMarkup}>
      <VStack centerHorizontal>
        <Text
          variant="heading2"
          style={{
            textAlign: "center",
          }}
        >
          {t(keys.deleteImagesConfirmation, {
            count: imageIds.length,
          })}
        </Text>
      </VStack>
    </Page>
  );
};
